import BaseView from "../core/views/BaseView";
import C_PointerEvt from "../core/const/C_PointerEvt";
import C_ViewType from "../const/C_ViewType";
import Button from "../core/ui/Button";
import C_Local from "../core/const/C_Local";
class TypeSelectView extends BaseView
{
    constructor()
    {
        super();

        this.addBackground();
        this.addBalanceInfo();
        this.addPlayStyles();
        this.addButtons();
    }


    addBackground()
    {
        this.layout.propHeightScale(this.bg, 100);
        this.layout.verticalAlignMiddle(this.bg);
        this.layout.horizontalAlignCenter(this.bg);
        this.addChild(this.bg);
    }


    addBalanceInfo()
    {
        this.balanceBg = this.assets.getSprite("player_balance_bg");
        this.layout.propHeightScale(this.balanceBg, 12);
        this.layout.verticalAlignTop(this.balanceBg);
        this.layout.horizontalAlignRight(this.balanceBg);
        this.addChild(this.balanceBg);

        let txtSize = this.layout.relHeight(20, this.balanceBg);

        let balanceTF = this.assets.getTF("BALANCE", txtSize, null, "#ffd800");
        this.layout.verticalAlignTop(balanceTF, 12.5, this.balanceBg);
        balanceTF.x = this.balanceBg.x + this.balanceBg.width*0.15;
        this.addChild(balanceTF);

        let coin1 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin1, 25, this.balanceBg);
        this.layout.verticalAlignTop(coin1, 10, this.balanceBg);
        coin1.x = this.balanceBg.x + this.balanceBg.width*0.35;
        this.addChild(coin1);

        let balancePoints = this.assets.getTF(this.model.getBalance(), txtSize);
        this.layout.verticalAlignTop(balancePoints, 12.5, this.balanceBg);
        balancePoints.x = coin1.x + coin1.width + this.balanceBg.width*.01;
        this.addChild(balancePoints);

        let balanceCurrency = this.assets.getTF("$" + (this.model.getBalance()/this.model.getCurrencyMultiplier()).toString(), txtSize);
        this.layout.verticalAlignTop(balanceCurrency, 12.5, this.balanceBg);
        balanceCurrency.x = this.balanceBg.x + this.balanceBg.width*.6;
        this.addChild(balanceCurrency);

        let coin2 = this.assets.getSprite("coin");
        this.layout.propHeightScale(coin2, 25, this.balanceBg);
        this.layout.verticalAlignTop(coin2, 10, this.balanceBg);
        coin2.x = this.balanceBg.x + this.balanceBg.width*0.79;
        this.addChild(coin2);

        let exchangeValue = this.assets.getTF("= $" + this.model.getCoinsRate(), txtSize, null, "#ffd800");
        this.layout.verticalAlignTop(exchangeValue, 12.5, this.balanceBg);
        exchangeValue.x = coin2.x + coin2.width + this.balanceBg.width*.01;
        this.addChild(exchangeValue);
    }


    addPlayStyles(){ }


    onTypeOver(e)
    {
        if(!e) return;

        let but = e.currentTarget;
        let bg = but.getChildAt(1);
        let tf = but.getChildAt(2);

        if (e.type == C_PointerEvt.OVER)
        {
            // bg.texture = this.roomBgTextureOver;
            // tf.style.fill = 0xffd800;

            bg.tint = this.roomOverTint;
            tf.style.fill = this.roomOverTint;
        }
        else if (e.type == C_PointerEvt.OUT)
        {
            // bg.texture = this.roomBgTexture;
            // tf.style.fill = 0x00baff;
            bg.tint = this.roomTint;
            tf.style.fill = this.roomTint;
        }
    }


    onTypeSelected(e)
    {
        this.controller.selectType(e.target.viewType);
    }


    addButtons()
    {
        this.backButton = new Button("back_but", "back_but_glow", "back_but_glow");
        this.layout.propHeightScale(this.backButton, 10);
        this.layout.horizontalAlignLeft(this.backButton, 3);
        this.layout.verticalAlignBottom(this.backButton, 3);
        this.addChild(this.backButton);

        this.paytableButton = new Button("paytable_but", "paytable_but_glow", "paytable_but_glow");
        this.layout.propHeightScale(this.paytableButton, 10);
        this.layout.horizontalAlignLeft(this.paytableButton, 3);
        this.layout.verticalAlignBottom(this.paytableButton, 14);
        this.addChild(this.paytableButton);

        let soundSkin = this.localData.getBooleanValue(C_Local.SOUND_ENABLED, this.soundEnabled) ? "btnSound" : "btnSoundOff";
        this.soundButton = new Button(soundSkin, soundSkin, soundSkin);
        this.layout.propHeightScale(this.soundButton, 10);
        this.layout.horizontalAlignRight(this.soundButton, 3);
        this.layout.verticalAlignBottom(this.soundButton, 14);
        this.addChild(this.soundButton);

        this.backButton.on(C_PointerEvt.DOWN, this.onBack, this);
        this.paytableButton.on(C_PointerEvt.DOWN, this.onPaytable, this);
        this.soundButton.on(C_PointerEvt.DOWN, this.onSoundTrigger, this);
    }


    onPaytable(e)
    {
        if (e)
        {
            e.stopPropagation();
        }
        this.controller.openPaytable();
    }


    onSoundTrigger(e)
    {
        if (e)
        {
            e.stopPropagation();
        }

        this.sound.toggleMusic();
        this.sound.toggleSound();

        let soundSkin = this.localData.getBooleanValue(C_Local.SOUND_ENABLED, this.soundEnabled) ? "btnSound" : "btnSoundOff";
        this.soundButton.setSkins(soundSkin, soundSkin, soundSkin, soundSkin);
    }


    onBack(e)
    {
        if (e)
        {
            e.stopPropagation();
        }
        this.controller.goToRoomsMenu();
    }

}

export default TypeSelectView;

